
export const FETCH_DIALOGFLOW_REQUEST = "Fetch Dialog Flow Request";
export const FETCH_DIALOGFLOW_SUCCESS = "Fetch Dialog Flow Success";
export const FETCH_DIALOGFLOW_FAILURE = "Fetch Dialog Flow Failure";